import { FormModel } from "mvc-kit/forms";
// src/modules/AuthWrapper2/models/LoginModel.ts
var LoginModel = class extends FormModel {
	validate(state) {
		const errors = {};
		if (!state.email.trim()) errors.email = "Required";
		else if (!state.email.includes("@")) errors.email = "Invalid email";
		if (!state.password) errors.password = "Required";
		return errors;
	}
	setEmail(email) {
		this.set({ email });
	}
	setPassword(password) {
		this.set({ password });
	}
};
export { LoginModel };

//# sourceMappingURL=LoginModel.js.map